module.exports = __webpack_public_path__ + "static/media/Clamperl_gaussian2.d964f0b8.png";